// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-below-row-left';

export const Component = () => (
  <path d='m6.705 16.704 4.31-3.88-.67-.719-5.7 5.077 5.7 5.124.67-.719-4.359-3.927H24.52v-.958H6.704v.002Zm17.816-5.892V2H0v8.813h24.521ZM7.855 9.855H.958V2.958h6.897v6.897Zm7.854 0H8.812V2.958h6.897v6.897Zm7.854-6.896v6.896h-6.897V2.96h6.897Z' />
);

export const viewBox = '0 0 25 25';
